import EventTypes from "@wesstron/utils/Api/constants/eventTypes";
import {isArray, isString, memoize} from "lodash";
import {createSelector} from "reselect";
import {getLatestCycleEvents4Animal} from "../utils/AnimalDocumentsUtils";
import {getPigBalance} from "../utils/EventUtils";
import {formatLocationName} from "../utils/global-formatters/formatLocationName";
import {getAllAnimals} from "./animalSelector";
import {makeGetBuildingsMap} from "./buildingsSelector";
import {getAllEventsForFarm} from "./eventsSelectors";
import {getAllGroups} from "./groupSelector";
import utilSelectors from "./utilSelectors";
import {createKeyToValueDictionary} from "../utils/Utils";

export const InventorySortType = {
    BY_ANIMAL_NUMBER_ASC: "SORT_BY_ANIMAL_NUMBER_ASC",
    BY_ANIMAL_NUMBER_DESC: "SORT_BY_ANIMAL_NUMBER_DESC",
    BY_ANIMAL_TYPE_ASC: "SORT_BY_ANIMAL_TYPE_ASC",
    BY_ANIMAL_TYPE_DESC: "SORT_BY_ANIMAL_TYPE_DESC",
    BY_LOCATION_ASC: "SORT_BY_LOCATION_ASC",
    BY_LOCATION_DESC: "SORT_BY_LOCATION_DESC",
    BY_AGE_ASC: "SORT_BY_AGE_ASC",
    BY_AGE_DESC: "SORT_BY_AGE_DESC",
    BY_HERD_NUMBER_ASC: "SORT_BY_HERD_NUMBER_ASC",
    BY_HERD_NUMBER_DESC: "SORT_BY_HERD_NUMBER_DESC",
    BY_RACE_ASC: "SORT_BY_RACE_ASC",
    BY_RACE_DESC: "SORT_BY_RACE_DESC",
    BY_CODE_RACE_ASC: "SORT_BY_CODE_RACE_ASC",
    BY_CODE_RACE_DESC: "SORT_BY_CODE_RACE_DESC",
    BY_TATTOO_NUMBER_ASC: "SORT_BY_TATTOO_NUMBER_ASC",
    BY_TATTOO_NUMBER_DESC: "SORT_BY_TATTOO_NUMBER_DESC",
};

export const getSort = (state) => state.inventory.inventorySort;

export const getShowDead = (state, props) => state.inventory.showDead;

export const getShowDeleted = (state, props) => state.inventory.showDeleted;

export const getShowEmpty = (state, props) => state.inventory.showEmpty;

export const getFormatAge = (state) => state.inventory.formatAge;

export const getRaceFilter = (state) => state.inventory.raceFilter;

export const getInventoryColumnsObject = (state) => {
    return state.inventory.inventoryColumns;
};

export const getInventoryColumns = (state) => state.inventory.inventoryColumns;

export const getPigletNumber = createSelector(
    [getAllEventsForFarm],
    (allEventsForFarm) => {
        const result = {};
        for (const event of allEventsForFarm) {
            if (
                ![
                    EventTypes.PARTURITION,
                    EventTypes.FALL_PIGLETS,
                    EventTypes.SEPARATION_TO_MOMMY,
                    EventTypes.SEPARATION,
                    EventTypes.MOMMY,
                    EventTypes.INSEMINATION,
                    EventTypes.PARTURITION_STATE,
                    EventTypes.SEPARATION_TO_MOMMY_GILTS,
                    EventTypes.TATTOO,
                ].includes(event.EvCode)
            )
                continue;
            if (!result[event.AnmID]) result[event.AnmID] = [];
            result[event.AnmID].push(event);
        }
        for (const anmID in result) {
            const eventsInCycle = getLatestCycleEvents4Animal(result[anmID]);
            result[anmID] = getPigBalance(eventsInCycle, true);
        }
        return result;
    }
);

const getBuildingsMap = makeGetBuildingsMap();

export const getLocationFormatter = createSelector(
    [utilSelectors.getDevices, getBuildingsMap],
    (devicesList, buildingsMap) => {
        return memoize(
            (locationId) => {
                return formatLocationName(locationId, {
                    nameDeep: 3,
                    buildingsMap,
                    devicesList,
                });
            },
            (location) =>
                isArray(location)
                    ? location.join(",")
                    : isString(location)
                      ? location
                      : ""
        );
    }
);

export const getInventoryList = createSelector(
    getAllAnimals,
    getAllGroups,
    (animals, groups) => {
        return {
            animals: createKeyToValueDictionary(animals, "AnmID"),
            groups: createKeyToValueDictionary(groups, "AnmGrp"),
        };
    }
);
